import { languageName } from '@boViews/shared/LanguageTabs/languageName';
import { compactI18n, displayText, parseI18n } from '@src/i18n';

// Title of a test to display (its i18n JSON string read in French, else in the first language that has one), or ''
// when no language has one.
export const testTitle = (test) => displayText(compactI18n(parseI18n(test.title)));

// Full name, in `locale`, of the catalogue language `languageId` (`languagesOptions`: its id labelled by its
// code), or null when it is missing or unknown.
export const languageLabel = (languagesOptions, languageId, locale) => {
    const code = languagesOptions.find((option) => option.value === languageId)?.label;
    return code ? languageName(code, locale) : null;
};
